import { Component, OnInit, TemplateRef, viewChild, ViewChild } from '@angular/core';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { DynamictableComponent } from 'src/app/shared/dynamictable/dynamictable.component';
import { MatDialog } from '@angular/material/dialog';
import { CommonModule, formatDate } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ApprovalDashBoardService } from "src/app/services/approval-dashboard/approval-dashboard.service"
import Swal from 'sweetalert2';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { BillingAdjustmentDetails, InvoiceDetails } from 'src/app/Models/invoiceDetails';
import { AuthService } from 'src/app/services/auth/auth.service';
import { saveAs } from "file-saver";
import { ToastrService } from "ngx-toastr";
import { NgxSpinnerModule } from "ngx-spinner";
import { NgxSpinnerService } from 'ngx-spinner';
import { FormBuilder, FormGroup,FormsModule, Validators,ReactiveFormsModule, FormControl } from '@angular/forms';
import { MatError } from '@angular/material/form-field';
import { MatAccordion, MatExpansionModule } from '@angular/material/expansion';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { BillingAdjustmentStatusEnumDisplay } from 'src/utilities';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MsalService } from '@azure/msal-angular';
import { BulkRequestService } from 'src/app/services/bulk-request/bulk-request.service';
import { SharedModule } from 'src/app/shared/shared.module';
import { SpinnerService } from 'src/app/services/spinner/spinner.service';
import { BillingAdjustmentStatusEnum, dateRangeValidator, formatDateforBAT, FilterDto } from 'src/utilities';

@Component({
    selector: 'app-bulk-request-gbs-pending',
    imports: [FormsModule, MatDatepickerModule, MatSelectModule, MatError, MatNativeDateModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, DynamictableComponent, CommonModule, MatProgressSpinnerModule, NgxSpinnerModule, MatTableModule, SharedModule],
    templateUrl: './bulk-request-gbs-pending.component.html',
    styleUrl: './bulk-request-gbs-pending.component.scss'
})
export class BulkRequestGbsPendingComponent implements OnInit {

@ViewChild('template1') template1: TemplateRef<any>; 
  @ViewChild(DynamictableComponent) dynamicTable: DynamictableComponent; // Reference to dynamic table for pagination control
  selectedData: any;
  isGoodWillRequest: boolean = false;
  chooseDialogRef: any;
  detailData: any[] = [];
  invoiceData:any[]=[];
  isLoader: boolean = true;
  isDetailView = false;
  @ViewChild('detailsTemplate') detailsTemplate: TemplateRef<any>;
detailsModalRef: any;



  // ✅ Used for master table display
  readonly mainTableFieldMapping = [
    { label: 'Adj Req Id', propertyName: 'detailedAdjSubId' },
    { label: 'Requested Date', propertyName: 'adjRequestDate' },
    { label: 'Billing Site', propertyName: 'billingSite' },
    { label: '#MMS', propertyName: 'mms' },
    { label: 'Customer Name', propertyName: 'custName' },
    { label: 'Amount', propertyName: 'totalCorrectCharges' },
    {label:'Check Request',propertyName:'checkRequest'},
    { label: 'Adjustment Type', propertyName: 'brAdjType' },
    { label: 'AE/Sales Contact', propertyName: 'ae' },
    { label: 'Remit Address', propertyName: 'remitAddress' },
    {label:'Requestor',propertyName:'requestor'},
    {label:'Status',propertyName:'statusDesc'},
    {label:'Invoice Number',propertyName:'invoiceNumber'},
    {label:'Statment Number',propertyName:'statementNumber'},
    // {label:'GBS Remarks',properyName:'gbsRemarks'},
    // {label:'GBS Status',propertyName:'gbsStatus'},
    //{label:'MI Remarks',propertyName:'rejectionReason'},
    
       {
      label: 'Action', propertyName: 'icon',
      icons: [{ toolTip: 'Accept/Reject', icon: 'gavel', callFrom: 'acc/rej'},
      { toolTip: 'View Statement Details', icon: 'remove_red_eye', callFrom: 'viewDetails' },
      { toolTip: 'Download Files', icon: 'download' , callFrom:'download'},
      ]
    }
  ];

  // ✅ Used for detail table display
  readonly detailTableFieldMapping = [
    { label: 'Adj Req Id', propertyName: 'adjReqId' },
    { label: 'Total Customers', propertyName: 'customerCount' },
    { label: 'Adjustment Type', propertyName: 'brAdjType' },
    { label: 'Description', propertyName: 'descriptionComment' },
    { label: 'Amount', propertyName: 'adjNetAmount' },
    { label: 'Special Instructions', propertyName: 'specialInstructions' },
    { label: 'Requested Date', propertyName: 'adjRequestDate' },
    { label: 'Requester', propertyName: 'requestor' },
    //{ label: 'MI Remarks', propertyName: 'rejectionReason' }
  ];

   readonly mainRequestInfo = [
    { label: 'Adj Req Id', propertyName: 'detailedAdjSubId' },
    { label: 'Requested Date', propertyName: 'adjRequestDate' },
    { label: 'Billing Site', propertyName: 'billingSite' },
    { label: '#MMS', propertyName: 'mms' },
    { label: 'Customer Name', propertyName: 'custName' },
    { label: 'Amount', propertyName: 'totalCorrectCharges' },
    {label:'Check Request',propertyName:'checkRequest'},
    { label: 'Adjustment Method', propertyName: 'adjustmentMethod' },
    { label: 'AE/Sales Contact', propertyName: 'ae' },
    { label: 'Remit Address', propertyName: 'remitAddress' },
    { label: 'MI Status', propertyName: 'status' },
    { label: 'Actioned By (MI)', propertyName: 'approver' },
    { label: 'MI Remarks', propertyName: 'rejectionReason' },
    { label: 'GBS Status', propertyName: 'gbsStatus' },
    { label: 'Actioned By (GBS)', propertyName: 'gbsApprover' },
    { label: 'GBS Remarks', propertyName: 'reason' },
  ];
 invoiceDataSource = new MatTableDataSource<InvoiceDetails>([]);
  checked: boolean = true;
  dataSource = new MatTableDataSource<BillingAdjustmentDetails>([]);
  isAccepted: boolean = true;
  firstFormGroup: FormGroup;
  panels: any[] = [];
  isLoading: boolean = false;
  totalCount: number = 0; 
  pageSize: number = 20;  
  currentPageIndex: number = 1; 
  currentAppliedFilters: FilterDto[] = [];

  statusOptions = [
    { value: 6, label: '✅ Completed' },
    { value: 7, label: '📥 Received' },
    { value: 8, label: '⏳ Waiting for Approval' },
    { value: 9, label: '✏️ Sent to Corrections' },
    { value: 10, label: '🕓 Pending Rebill' },
    { value: 11, label: '❌ Rejected' },
    { value: 13, label: '❓ GBS Need More Info' }
  ];

  // Helper to get status value from statusDesc
  getStatusValueFromDesc(desc: string): number | null {
    const found = this.statusOptions.find(opt => desc && opt.label.replace(/[^a-zA-Z]/g, '').toLowerCase() === desc.replace(/[^a-zA-Z]/g, '').toLowerCase());
    return found ? found.value : null;
  }

  constructor(private dialog: MatDialog,
    private modalService: BsModalService,
    private approvalDashBoardService: ApprovalDashBoardService,
    private authService: AuthService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private spinner: SpinnerService,
    private bulkRequestService: BulkRequestService,
    private msalService: MsalService,
  ) {
   }

  ngOnInit(): void {
   this.getAdjustmentDetails(1, 20) 
   this.firstFormGroup = new FormGroup({
    reason: new FormControl('', [
      Validators.maxLength(1000),
      Validators.pattern(/^[a-zA-Z0-9\s!@#$%^&*()_+={}\[\]|\\:;'"<>,.?/-`~|-]*$/)
    ]),    
    invoiceNumber: new FormControl("", [Validators.required, Validators.maxLength(15), Validators.pattern(/^^[0-9]+$/)]),
    statementNumber: new FormControl("", [Validators.required, Validators.maxLength(15), Validators.pattern(/^^[0-9]+$/)]),
    status : new FormControl("", Validators.required)
  });
  }

  getAdjustmentDetails(pageIndex: number = 1, pageSize: number = 20, filters: FilterDto[] = [], isRefresh: boolean = false)
  {
    this.spinner.showSpinner();    
    this.isLoader = true;
    
    if (isRefresh) {
      pageIndex = 1;
      pageSize = 20;
      this.pageSize = 20;
      filters = [];
      this.currentAppliedFilters = [];
    }
    
    const isFilterChange = filters.length > 0;
    const isPaginationChange = filters.length === 0 && !isRefresh;
    
    if (isPaginationChange && this.currentAppliedFilters.length > 0) {
      filters = [...this.currentAppliedFilters];
    }

    if (isFilterChange) {
      pageIndex = 1;
      this.currentAppliedFilters = [...filters];
    }
    
    let obj : any ={
      StartDate : null,
      EndDate:null,
      StatusId: [5, 7, 8, 9, 10],
      UserId: null,
      IsFromHistory: false,
      PageNumber: pageIndex,
      PageSize: pageSize,
      filters: filters.map(f => ({
        column: f.column,
        operator: f.operator || 'contains',
        value: f.value?.toString() || '', 
      }))
    }
    
    
    
    this.bulkRequestService.getBulkBillingAdjustmentForGBS(obj).subscribe({
      next: response => {
        
        const data = response.data || response;
        this.totalCount = response.totalCount || data.length;
        
        this.dataSource.data = data;
        const notYetStatuses = [1,2,3,4,5,14,15];
        this.dataSource.data.forEach(x => {
          x.adjRequestDate = formatDate(x.adjRequestDate,'MM/dd/yyyy', "en-US");
          x.statusDesc = x.statusId == 5 ?  BillingAdjustmentStatusEnumDisplay[7] :  BillingAdjustmentStatusEnumDisplay[x.statusId];
          x.gbsStatus = x.isGBSNMF
                                  ? BillingAdjustmentStatusEnumDisplay[BillingAdjustmentStatusEnum.GBSNeedMoreInformation] :
                                   notYetStatuses.includes(x.statusId) ? '--' : BillingAdjustmentStatusEnumDisplay[x.statusId];
                            
                                   if (
                                (x.gbsStatus === 'GBS Need More Information' && x.statusId !== BillingAdjustmentStatusEnum.Submitted ) ||
                                (x.gbsStatus !== '--' && x.gbsStatus !== 'GBS Need More Information')
                              ) {
                                x.status = BillingAdjustmentStatusEnumDisplay[BillingAdjustmentStatusEnum.MIApproved];
                              } else {
                
                                if(x.statusId==1){
                                  x.status = '--'
                                }else{
                                  x.status = BillingAdjustmentStatusEnumDisplay[x.statusId];
                                }             
                
                              }   
        });
        
        this.pageSize = pageSize;
        this.currentPageIndex = pageIndex;
        this.isLoader = false;
        this.spinner.hideSpinner();
        
        this.updatePaginatorState();
        
      },
      error: (error) => {
        console.error('Bulk GBS Dashboard: API call failed', error);
        this.spinner.hideSpinner();
        this.isLoader = false;
        this.toastr.error('Failed to load bulk GBS dashboard data. Please try again.', 'Error');
      }
    })
  }

  
  openAcceptOrRejectDialog(e) {
    this.selectedData = e.details;
    if (e.callFrom == 'acc/rej') {
      // Patch the form with the status value based on statusDesc
      const statusValue = this.getStatusValueFromDesc(this.selectedData.statusDesc);
      this.firstFormGroup.patchValue({
        status: statusValue
      });
      this.chooseDialogRef = this.modalService.show(this.template1, { backdrop: true, ignoreBackdropClick: true , class: 'template1-modal', });
    } else if (e.callFrom === 'download') {
      if(e.details.isFileUploaded)
      {
        this.spinner.showSpinner();
        this.approvalDashBoardService.DownloadUploadedFiles(e.details.adjReqId)
          .subscribe({
            next: data => {
              const filename = `AdjustmentRequest_${e.details.adjReqId}.zip`;  
              const blob = new Blob([data], { type: 'application/zip' });
              saveAs(blob, filename);
              this.spinner.hideSpinner();
              this.toastr.success('File Downloaded Successfully', 'Success');
            },
            error: () => {
              this.spinner.hideSpinner();
              this.toastr.error('Error downloading file', 'Error');
            }
          });
      }
else{
        this.toastr.warning('No Files Uploaded', 'warning');
      }
    }
          else if (e.callFrom === 'viewDetails') {
  this.isDetailView = true;
  this.loadDetailsByAdjReqId(e.details.detailedAdjSubId);
  // this.loadDetailsByDetailsId(e.details.detailedAdjSubId);

   this.detailsModalRef = this.modalService.show(this.detailsTemplate, {
    backdrop: true,
    class: 'modal-xl'
  });
}
  }

  closePopup1()
  {
    if (this.chooseDialogRef)
      {
        this.chooseDialogRef.hide();
        this.firstFormGroup.reset();
      }
  }
closeDetailsPopup() {
  if (this.detailsModalRef) {
    this.detailsModalRef.hide();
  }
  this.isDetailView = false;
}

  onNext(): void {
    if (this.firstFormGroup.invalid) {
      this.firstFormGroup.markAllAsTouched(); 
      return;
    }
    this.spinner.showSpinner();
    this.isLoading = false;
    const reason = this.firstFormGroup.get('reason')?.value;
    const status = this.firstFormGroup.get('status')?.value;
    const Inv = this.firstFormGroup.get('invoiceNumber')?.value;
    const stmt = this.firstFormGroup.get('statementNumber')?.value;

    const requestBody = {
          StatusId: status,
          adjReqId: this.selectedData.adjReqId,
          UpdatedBy: this.authService.getUserGDId(),
          reason: reason,
          stmtblk: stmt,
          Invblk: Inv,
          adjSubId: this.selectedData.adjSubId,
          OrigStmtConfigurations: []
          // StatementDate: formValue.statementDate ? formatDateforBAT(formValue.statementDate) : null,
          // StatementAmt: formValue.statementAmt ? Number(formValue.statementAmt) : null,
          // InvAdjAmt: formValue.invAdjAmt ? Number(formValue.invAdjAmt) : null,
          // RebillCMF: formValue.rebillCmf ? Number(formValue.rebillCmf) : null,
          // RebillMMS: formValue.rebillMms ? Number(formValue.rebillMms) : null,
          // RebillCustomerName: formValue.rebillCustomerName || null,
          // RebillStatementNo: formValue.rebillStatementNo || null,
          // RebillInvoiceNo: formValue.rebillInvoiceNo || null,
          // RebillAmount: formValue.rebillAmount ? Number(formValue.rebillAmount) : null,
          // CheckDetails: formValue.checkDetails || null,
          // RefundStatus: formValue.refundStatus || null,
          // SalesforceCaseNumber: formValue.salesforceCaseNumber || null
        };

    this.approvalDashBoardService.UpdateApprovalStatusGBS(requestBody).subscribe({
      next: response => {
        this.isLoading = false;
        this.spinner.hideSpinner();
        this.closePopup1()
        if (response == 2) {
          Swal.fire({
            title: "Status Updated Successfully.",
            icon: "success",
            confirmButtonText: "OK",
            allowOutsideClick: false,
          }).then(() => {
      this.getAdjustmentDetails(this.currentPageIndex, this.pageSize);
    });
        }
        else if(response == 1){
          Swal.fire({
            title: "Request has already been processed. Please refresh the page.",
            icon: "error",
            confirmButtonText: "OK",
            allowOutsideClick: false,
          }).then(() => {
      this.getAdjustmentDetails(this.currentPageIndex, this.pageSize);
    });
        }
        else{
          this.isLoading = false;
          Swal.fire({
            title: "Error Occured.",
            icon: "error",
            confirmButtonText: "OK",
            allowOutsideClick: false,
          }).then(() => {
      this.getAdjustmentDetails(this.currentPageIndex, this.pageSize);
    });
        }
      }
    });
  }

  private updatePaginatorState() {
    setTimeout(() => {
      if (this.dynamicTable && this.dynamicTable.paginator) {
        const paginatorPageIndex = Math.max(0, this.currentPageIndex - 1);
        
        this.dynamicTable.paginator.length = this.totalCount;
        this.dynamicTable.paginator.pageSize = this.pageSize;
        this.dynamicTable.paginator.pageIndex = paginatorPageIndex;
        
      } else {
        console.warn('⚠️ Cannot update paginator - dynamicTable or paginator not available');
      }
    }, 0);
  }

 // ✅ This is the critical function you asked to keep
loadDetailsByAdjReqId( detailedAdjSubId: string): void {
  this.spinner.showSpinner();
  const selectedRow = this.dataSource.data.find(x => x.detailedAdjSubId === detailedAdjSubId);
  if (selectedRow) {
    this.detailData = [selectedRow]; // Wrap in array for table binding
    this.invoiceDataSource.data = this.detailData;
  } else {
    this.detailData = [];
    this.invoiceDataSource.data = [];
  }
  this.spinner.hideSpinner();
}


  showTooltip = false;
  tooltipSvg = `
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" width="200" height="200">
    <text x="10" y="20" class="tooltip-text">$0 - $2,499:  Supervisor</text><br/>
    <text x="10" y="40" class="tooltip-text">$0 - $4,999:  Manager</text><br/>
    <text x="10" y="60" class="tooltip-text">$0 & above:  District Mgr/ Finance Director</text><br/>
    <text x="10" y="80" class="tooltip-text">Any amount of goodwill request: Requires approval from MI Director of Finance</text>
  </svg>
`;
}

